import { PayloadAction } from 'typesafe-actions';
import { CardsState, CardContextActionTypes, CardsListFilters } from './types';

const CardsReducer = (state: CardsState, action: PayloadAction<CardContextActionTypes, any>): CardsState => {
  switch (action.type) {
    case CardContextActionTypes.SetCardsListFilters:
      return {
        ...state,
        cardsListFilters: action.payload as Partial<CardsListFilters>,
      };
    case CardContextActionTypes.ResetCards:
      return {
        ...state,
        cardListData: null,
      };
    case CardContextActionTypes.SetPagination:
      return {
        ...state,
        pagination: { ...state.pagination, ...action.payload.pagination },
        meta: { timestamp: action.payload.timestamp },
      };

    default:
      return state;
  }
};

export { CardsReducer };
